<div class="embedcode" *ngIf="entity && baseurl">
	<label for="embedcode">{{ 'EMBED' | translate }}</label>
	<div class="embedcode-textarea">
		<a class="button" [href]="getPreviewLink()" target="_blank"><i class="fa fa-external-link"></i></a>
		<button class="button" (click)="copyEmbedCodeToClipboard(embedcodeTextarea.value);"><i class="fa fa-copy"></i> {{ 'COPY' | translate }}</button>
		
		<textarea name="embedcode" #embedcodeTextarea (click)="embedcodeTextarea.select()" [value]="getEmbedCode()"></textarea>
	</div>
</div>
